import ApiService from "./api.service";

class InterpellationService extends ApiService {
    getAllInterpelattions(page) {
        return this.get(`api/management/interpellation/getAllInterpellations/${page}`)
    }
    searchInterpellation(data) {
        return this.post(`api/management/interpellation/search`, data);
    }
    deleteInterpelation(id) {
        return this.delete(`api/management/interpellation/${id}`)
    }
    updateInterpellation(data) {
        return this.post(`api/management/interpellation/${data.id}`, data)
    }
    addInterpellation(data) {
        return this.post(`api/management/interpellation`, data)
    }
    addInterpellationAttachement(data) {
        return this.post(`api/management/interpellation/addInterpellationAttachement`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    }
    deleteFile(intId, fileId) {
        return this.delete(`api/management/interpellation/deleteFile/${intId}/${fileId}`)
    }
    downloadAttachment(intId, fileId) {
        return this.get(`api/management/interpellation/downloadAttachment/${intId}/${fileId}`, { responseType: "arraybuffer" })
    }
    getInterpellationResponses(data) {
        return this.put(`api/management/interpellation/${data.id}/responses`, data)
    }
    deleteInterpelationResponse(interpellationId, id) {
        return this.delete(`api/management/interpellation/${interpellationId}/responses/${id}`)
    }
    addInterpellationResponse(data) {
        return this.post(`api/management/interpellation/${data.id}/responses`, data);
    }
    getUsersForInterpelattions() {
        return this.get(`api/management/interpellation/getUsersForInterpelattions`);
    }
    getNewInterpelationsCount() {
        return this.get(`api/management/interpellation/getNewInterpelationsCount`);
    }
}

export default new InterpellationService();